import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { unsplash, imageIds } from '@/lib/images'

const categories = [
  { label: 'Bestsellers', href: '/shop?sort=featured', image: imageIds.bottle1 },
  { label: 'New arrivals', href: '/shop?sort=newest', image: imageIds.bottle4 },
  { label: 'Discovery sets', href: '/product/discovery-set-01', image: imageIds.bottle2 },
  { label: 'Refills', href: '/shop?max=120', image: imageIds.bottle7 },
]

export function HomeCategories() {
  return (
    <section className="bg-paper py-24 lg:py-32">
      <div className="mx-auto max-w-content px-6 lg:px-10">
        <div className="mx-auto mb-12 max-w-text-block text-center">
          <p className="mb-4 font-condensed text-xs uppercase tracking-[0.2em] text-wd-orange">Browse by</p>
          <h2 className="font-display text-display-lg lg:text-display-xl font-normal normal-case leading-[0.95] text-carbon">
            Shop the way in
          </h2>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((cat, index) => (
            <motion.div
              key={cat.label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
            >
              <Link to={cat.href} className="group block">
                <div className="relative mb-4 aspect-[3/4] overflow-hidden bg-card">
                  <img
                    src={unsplash(cat.image, 600, 800)}
                    alt={cat.label}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-ink/0 transition-colors duration-500 group-hover:bg-ink/10" />
                </div>
                <p className="font-condensed text-xs uppercase tracking-[0.2em] text-carbon transition-colors group-hover:text-wd-orange">
                  {cat.label}
                </p>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  )
}
